export default __webpack_public_path__ + "5c88fdbd5cb0aebc47a192b3029bd3a6.svg";